var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAlignmentCenter = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.25 5.19328C5.25 4.81039 5.56039 4.5 5.94328 4.5H18.0567C18.4396 4.5 18.75 4.81039 18.75 5.19328V5.19328C18.75 5.57616 18.4396 5.88655 18.0567 5.88655H5.94328C5.56039 5.88655 5.25 5.57616 5.25 5.19328V5.19328ZM6.75 9.66807C6.75 9.25037 7.08861 8.91176 7.5063 8.91176H16.4937C16.9114 8.91176 17.25 9.25037 17.25 9.66807V9.66807C17.25 10.0858 16.9114 10.4244 16.4937 10.4244H7.5063C7.08861 10.4244 6.75 10.0858 6.75 9.66807V9.66807ZM5.25 14.2059C5.25 13.7882 5.58861 13.4496 6.0063 13.4496H17.9937C18.4114 13.4496 18.75 13.7882 18.75 14.2059V14.2059C18.75 14.6236 18.4114 14.9622 17.9937 14.9622H6.0063C5.58861 14.9622 5.25 14.6236 5.25 14.2059V14.2059ZM6.75 18.7437C6.75 18.326 7.08861 17.9874 7.5063 17.9874H16.4937C16.9114 17.9874 17.25 18.326 17.25 18.7437V18.7437C17.25 19.1614 16.9114 19.5 16.4937 19.5H7.5063C7.08861 19.5 6.75 19.1614 6.75 18.7437V18.7437Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAlignmentCenter);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/alignment-center.709e480473bf4619fe64a2ff45cba287.svg";